/** Beheert de extractie en verwerking van project- en contexttags uit taaktitels. */
// @ts-check
import { ensureTermsExist as checkAndAddTerms } from '@/services/tagService';

/** Manages the persistence and retrieval of project and context tags in Firestore. */

/**
 * Returns the combined projects for a task (modern + legacy).
 * @param {any} task
 * @returns {string[]}
 */
export const getTaskProjects = (task) =>
  (task.projects || []).concat(
    task.project
      ? Array.isArray(task.project)
        ? task.project
        : [task.project]
      : [],
  );

/**
 * Returns the combined contexts for a task (modern + legacy).
 * @param {any} task
 * @returns {string[]}
 */
export const getTaskContexts = (task) =>
  (task.contexts || []).concat(
    task.context
      ? Array.isArray(task.context)
        ? task.context
        : [task.context]
      : [],
  );

/**
 * Normalizes task tags, deduplicating case-insensitively.
 * @param {any} task
 * @returns {{ allProjects: string[], allContexts: string[] }}
 */
export const normalizeTaskTags = (task) => {
  if (!task) return { allProjects: [], allContexts: [] };

  const mergeUnique = (arr, legacy) => {
    const combined = (arr || [])
      .concat(legacy ? (Array.isArray(legacy) ? legacy : [legacy]) : [])
      .filter(Boolean);
    const uniqueMap = new Map();
    combined.forEach((item) => {
      const lc = item.toLowerCase();
      if (!uniqueMap.has(lc)) uniqueMap.set(lc, item);
    });
    return Array.from(uniqueMap.values());
  };

  return {
    allProjects: mergeUnique(task.projects, task.project),
    allContexts: mergeUnique(task.contexts, task.context),
  };
};

export { checkAndAddTerms };
